
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataObraService {
  private _obraId = new BehaviorSubject<number | null>(null);
  obraId$ = this._obraId.asObservable();

  private _isFichaDaObraActive = new BehaviorSubject<boolean>(false);
  isFichaDaObraActive$ = this._isFichaDaObraActive.asObservable();

  setObraId(id: number | null): void {
    this._obraId.next(id);
  }

  setFichaDaObraActive(isActive: boolean): void {
    this._isFichaDaObraActive.next(isActive);
  }
}
